import { EstimateInfo } from '@paragon/contract-library';

export function getDefaultEstimateInfo(
  name: string,
  createdByEmail: string,
  componentDesignQuantities: { [guid: string]: number },
): Omit<EstimateInfo, 'projectGuid'> {
  return {
    guid: crypto.randomUUID(),
    name,
    createdByEmail,
    created: new Date().toISOString(),
    userSpecifiedLumberPrices: [],
    userSpecifiedPlatePrices: {},
    userSpecifiedHangerPrices: {},
    userSpecifiedCustomHangerPrices: {},
    includeHangerPricing: false,
    otherMaterials: [],
    componentDesigns: componentDesignQuantities,
    laborCostPerUnit: 0,
    laborCostUnit: 'LF',
    freightCostPerMile: 0,
    numberOfMilesOneWay: 0,
    numberOfTruckloads: 0,
    overhead: 0,
    marginPercentage: 0,
    totalSquareFeet: 0,
    notes: null,
  };
}
